import { render, staticRenderFns } from "./HomeDashboard.vue?vue&type=template&id=474cd6d8&"
import script from "./HomeDashboard.vue?vue&type=script&lang=ts&"
export * from "./HomeDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./HomeDashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports